import { Node, Edge } from "@xyflow/react";
import useOrgchartAreasStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Areas/store";
import { IChangeNodesVisibility } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Utils/utils.models";
// eslint-disable-next-line
import { getAutoLayoutWorker } from "../workers/getOrgchartWebWorker";

let AutoLayoutWorker: Worker | undefined;

interface IWebWorkerReturnType {
  nodes: Node[];
  edges: Edge[];
}

const changeNodesVisibility = ({
  clickedNodeId,
  isClickedNodeCollapsed,
  edges,
}: IChangeNodesVisibility) => {
  const newNodes: Node[] = [];
  const updatedChildren: Node[] = useOrgchartAreasStore
    .getState()
    .allNodes.filter((node) => node.data.parentId === clickedNodeId)
    .map((child) => ({
      ...child,
      hidden: !isClickedNodeCollapsed,
    }));

  if (isClickedNodeCollapsed) {
    useOrgchartAreasStore.getState().nodes.forEach((node) => {
      if (
        node.id === "root" ||
        (node.id !== "root" && node.data.parentId !== clickedNodeId)
      ) {
        newNodes.push(node);
      }
      if (node.data.parentId === clickedNodeId) {
        newNodes.push({
          ...node,
          hidden: !isClickedNodeCollapsed,
        });
      }
    });
    updatedChildren.forEach((updatedChild) => {
      if (!newNodes.find((node) => node.id === updatedChild.id)) {
        newNodes.push(updatedChild);
      }
    });
  } else {
    const targetNode = useOrgchartAreasStore
      .getState()
      .nodes.find((node) => node.id === clickedNodeId);
    if (!targetNode) {
      return null;
    }

    const newNodesArray: Node[] = [];
    const queue = [targetNode];

    while (queue.length > 0) {
      const current = queue.shift();
      const children = useOrgchartAreasStore
        .getState()
        .nodes.filter((node) => node.data.parentId === current?.id);
      newNodesArray.push(...children);
      queue.push(...children.map((child) => child));
    }

    newNodesArray.forEach((node) => {
      if (node.data.hasChildren) {
        useOrgchartAreasStore
          .getState()
          .setChildrenCollapsedStatus(
            new Map(
              useOrgchartAreasStore.getState().childrenCollapsedStatus
            ).set(node.id, true)
          );
      }
    });

    useOrgchartAreasStore
      .getState()
      .nodes.map((node) =>
        !newNodesArray.find((newNode) => newNode.id === node.id)
          ? newNodes.push(node)
          : null
      );
  }

  if (!AutoLayoutWorker) {
    AutoLayoutWorker = getAutoLayoutWorker();
  }

  if (typeof AutoLayoutWorker !== "undefined") {
    AutoLayoutWorker.postMessage({ nodes: newNodes, edges });
    AutoLayoutWorker.onmessage = (
      event: MessageEvent<IWebWorkerReturnType>
    ) => {
      useOrgchartAreasStore.getState().setNodes(event.data.nodes);
    };
  }

  return null;
};

export default changeNodesVisibility;
